import React, { useEffect, useState } from "react";

const emptyForm = {
  name: "",
  key: "",
  sectionType: "custom",
  isPublished: true,
  sortOrder: 0,
};

const SectionFormModal = ({ open, initial, sectionTypes, busy, onClose, onSubmit }) => {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (!open) return;
    if (initial) {
      setForm({
        name: initial.name || "",
        key: initial.key || "",
        sectionType: initial.sectionType || "custom",
        isPublished: Boolean(initial.isPublished),
        sortOrder: initial.sortOrder ?? 0,
      });
    } else {
      setForm(emptyForm);
    }
  }, [open, initial]);

  if (!open) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      name: form.name.trim(),
      key: form.key.trim().toLowerCase(),
      sectionType: form.sectionType.trim().toLowerCase(),
      isPublished: form.isPublished,
      sortOrder: Number(form.sortOrder) || 0,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-lg rounded-3xl border border-slate-200 bg-white p-6 shadow-2xl"
      >
        <h3 className="text-lg font-semibold text-slate-900">
          {initial ? "Edit section" : "Create section"}
        </h3>

        <div className="mt-5 space-y-4">
          <label className="block text-sm">
            <span className="mb-1.5 block font-medium text-slate-700">Name</span>
            <input
              required
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
              className="w-full rounded-2xl border border-slate-200 px-3 py-2.5 outline-none focus:border-emerald-500"
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1.5 block font-medium text-slate-700">Key</span>
            <input
              required
              value={form.key}
              onChange={(e) => setForm((f) => ({ ...f, key: e.target.value }))}
              className="w-full rounded-2xl border border-slate-200 px-3 py-2.5 outline-none focus:border-emerald-500"
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1.5 block font-medium text-slate-700">Section type</span>
            <select
              value={form.sectionType}
              onChange={(e) => setForm((f) => ({ ...f, sectionType: e.target.value }))}
              className="w-full rounded-2xl border border-slate-200 px-3 py-2.5 outline-none focus:border-emerald-500"
            >
              {sectionTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </label>
          <div className="flex items-center justify-between gap-4">
            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="checkbox"
                checked={form.isPublished}
                onChange={(e) => setForm((f) => ({ ...f, isPublished: e.target.checked }))}
              />
              Published
            </label>
            <label className="flex items-center gap-2 text-sm text-slate-700">
              Sort
              <input
                type="number"
                value={form.sortOrder}
                onChange={(e) => setForm((f) => ({ ...f, sortOrder: e.target.value }))}
                className="w-20 rounded-xl border border-slate-200 px-2 py-1.5"
              />
            </label>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-2xl border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={busy}
            className="rounded-2xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
          >
            {busy ? "Saving…" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SectionFormModal;
